import { NavSectionData } from '../../types/graphql/site-fixtures'
import { ContentfulNavListGroupSection } from '../contentful/nav/ContentfulNavListGroupSection'

import { NavAccordion } from './NavAccordion'
import { NavListSection } from './NavListSection'
import { NavRegionLocaleSection } from './NavRegionLocaleSection'
import { NavTileSection } from './NavTileSection'
import { NavRawHtmlSection } from './NavTray/styles'

import type { JSX } from 'react'

export function renderNavSection(section: NavSectionData, index: number = 0): JSX.Element | null {
  const key: string = `${section.id}-${index}`
  switch (section.__typename) {
    case 'NavAccordion':
      return <NavAccordion key={key} {...section} />
    case 'NavListSection':
      return <NavListSection key={key} {...section} />
    case 'NavListGroupSection':
      return <ContentfulNavListGroupSection key={key} {...section} />
    case 'NavTileSection':
      return <NavTileSection key={key} {...section} />
    case 'RawHtmlSection':
      return <NavRawHtmlSection key={key} {...section} />
    case 'NavRegionLocaleSection':
      return <NavRegionLocaleSection key={key} {...section} />
    default:
      return null
  }
}
